import { ChangeEvent, Dispatch, useEffect, useState } from 'react';

import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { HiSearch } from 'react-icons/hi';

import useDebounce from '../../../../hooks/useDebounce';
import { FiltersAction, FiltersActionKind } from '../../utils';

type TitlingSearchProps = {
  dispatch: Dispatch<FiltersAction>;
  value?: string;
};

const Search = ({ dispatch, value }: TitlingSearchProps) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const debouncedSearch = useDebounce((payload: string) => {
    dispatch({ type: FiltersActionKind.SEARCH, payload });
  }, 500);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const payload = e.target.value ?? '';
    setSearchValue(payload);
    debouncedSearch(payload);
  };

  useEffect(() => {
    setSearchValue(value ?? '');
  }, [value]);

  return (
    <InputGroup minW="170px" maxW="200px">
      <InputLeftElement pointerEvents="none" h="full">
        <HiSearch color="gray.300" />
      </InputLeftElement>
      <Input
        type="text"
        placeholder="Search"
        value={searchValue}
        bgColor="white"
        onChange={handleInputChange}
      />
    </InputGroup>
  );
};

export default Search;
